// Data services resolve with [] on any failure, so a refetch during an outage
// would otherwise blank a still-working UI whose signed URLs may still be valid.
export function acceptFetched<T>(current: T[], fetched: T[]): boolean {
  return fetched.length > 0 || current.length === 0;
}
